import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { FormGroup as t } from "@blueprintjs/core";
import n from "classnames";
import "./main.scss";
const h = ({
  label: s = "Field Label",
  labelFor: a,
  disabled: l = !1,
  helperText: o,
  inline: m = !1,
  fill: i,
  required: p = !1,
  requiredValidationMessage: e = void 0,
  inputContent: d = void 0,
  verticalSpacingSmall: f = !1
}) => /* @__PURE__ */ c(
  t,
  {
    labelFor: a,
    disabled: l,
    label: s && /* @__PURE__ */ r("span", { className: "sds_form-field-wrapper--label-text", children: s }),
    helperText: o,
    inline: m,
    fill: i,
    labelInfo: p && /* @__PURE__ */ r("span", { className: "sds_form-field-wrapper--required-asterisk", children: "*" }),
    className: n("sds_form-field-wrapper", {
      "margin__bottom--xx-large": !f
    }),
    children: [
      d,
      e && /* @__PURE__ */ r("div", { className: "sds_error", children: e })
    ]
  }
);
export {
  h as FormFieldWrapper
};
//# sourceMappingURL=index.js.map
